import { render, staticRenderFns } from "./faultrepaired.vue?vue&type=template&id=494fd053&scoped=true"
import script from "./faultrepaired.vue?vue&type=script&lang=js"
export * from "./faultrepaired.vue?vue&type=script&lang=js"
import style0 from "./faultrepaired.vue?vue&type=style&index=0&id=494fd053&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494fd053",
  null
  
)

export default component.exports